import { dotnetApi } from '@gik/core/api/ky/dotnetApi';
import type { ThankYouFormValues } from '../components/ThankYouForm/ThankYouForm';

export type ThankYouFormPayload = ThankYouFormValues;

interface SendThankYouMessageParams {
  inkindRouteId: string;
  orderId?: string;
  claimId?: string;
  payload: ThankYouFormPayload;
}

export async function sendThankYouMessage({
  inkindRouteId,
  orderId,
  claimId,
  payload: json,
}: SendThankYouMessageParams): Promise<Response> {
  if (!orderId && !claimId) {
    throw new Error('Either orderId or claimId must be provided');
  }

  const searchParams = {
    ...(orderId ? { orderId } : {}),
    ...(claimId ? { claimId } : {}),
  };

  return dotnetApi.post(`inkinds/${inkindRouteId}/sendThankYou`, {
    searchParams,
    json,
  });
}
